/* Some functions that are useful across all AG Grid tables */
import { store } from '@/store';

let clinvar_order = ['benign', 'benign/likely benign', 'likely benign', 'uncertain significance', 'conflicting interpretations of pathogenicity',
    'likely pathogenic', 'pathogenic/likely pathogenic', 'pathogenic', ''];

export default {

    /**
    * Creates a default column definition on grid creation.
    */
    createDefaultColDefs () {
        return {
            wrapText: 'true',
            sortable: 'true',
            cellStyle: { justifyContent: "flex-start", justifyItems: 'center', wordBreak: "normal" },
            flex: 1,
        }
    },

    /**
    * Takes a path to a deep object property with a specific separator and returns the according value.
    * @param {string} path - Path to the property (e.g. [variant].UTA_Adapter.gene_name) 
    * @param {object} obj - The object the property lives on
    * @param {string} separator - Separator for the path (default is '.')
    */
    resolveDeepProperty (path, obj = self, separator = '.') {
        var properties = Array.isArray(path) ? path : path.split(separator)
        return properties.reduce((prev, curr) => curr.includes('[0]') ? prev?.[curr.replace('[0]', '')][0] : prev?.[curr], obj)
    },

    /**
     * Comparator function for sorting ClinVar values in any table where they appear.
     * @param {String} pred1 - A ClinVar pathogenicity statement
     * @param {String} pred2 - Another ClinVar pathogenicity statement
     * @returns 1 if pred1>pred2, 0 if they are the same, -1 if pred2>pred1
     */
    clinvarComparator (pred1, pred2) {
        if (!pred1 || pred1 == '') return 1;
        if (!pred2 || pred2 == '') return -1;
        try {
            return clinvar_order.indexOf(pred1.toLowerCase()) - clinvar_order.indexOf(pred2.toLowerCase());
        }
        catch (e) {
            console.error(e);
            return 0;
        }
    },

    /**
    * Loads patient data (for the current MTB) from store and filters them.
    * Then saves it in a dedicated presentation_all_patients variable.
    */
    fetchPatients () {
        let all_patients_raw = store.getters.idList;
        if (all_patients_raw !== undefined) {
            Object.keys(all_patients_raw).map(key => {
                delete all_patients_raw[key]['id'];
                all_patients_raw[key]['id'] = String(key);
            })
            store.dispatch('setPresentationAllPatients', all_patients_raw);
        }
    },

    /**
     * Takes column definitions and returns an augmented, resized version of them based on window width.
     * Also requires a configs object that dictates at which breakpoints columns should be resized and which headers to use.
     * @param {Object} definitions - Table-specific AG Grid Column definitions
     * @param {Object} configs - Table-specific configuration for the column resizing
     * @param {Component} defaultHeaderComponent - Header Component to use for larger screen sizes
     * @param {Number} windowWidth - Width of the window at resize time
     * @param {Number} headerComponentBreakpoint - Table-specific screen width that specifies when to remove header components
     * @returns updated column definitions
     */
    resizeTable (definitions, configs, defaultHeaderComponent, windowWidth, headerComponentBreakpoint) {
        
    },


}